import React from "react";
import { Image, ImageStyle, Pressable, StyleSheet, useWindowDimensions, View } from "react-native";
import { useTheme, Surface, Paragraph } from "react-native-paper";
import images from "@styles/images";
import { Block } from "@block";
import { spacing } from "@styles/spacing";
import { StackSpacing } from "@components/spacing";
import AccountInfo from "../account-info/account-info";
import BoxRedeem from "../box-redeem/box-redeem";
import MyQrCode from "../my-qrcode/my-qrcode.web";
import { ScrollView } from "react-native-gesture-handler";
import { LinearGradient } from "expo-linear-gradient";
import ScreenNameType from "@navigation/nav-screens";
import ShortcutLink from "../shortcut-link/shortcut-link.web";
import { StackActions } from "@react-navigation/core";
import { SideMenuContext } from "../../side-menu/side-menu";
import { navigationRef } from "app/shared/util/root-navigator";

const AsideLeft = () => {
  const { colors, fonts } = useTheme();
  const { height } = useWindowDimensions();
  const { hideMenu } = React.useContext(SideMenuContext);
  type AsideLeftPropertyStyle = "footerDrawer" | "container" | "flex" | "imageStyles" | "titleFooterStyles";
  const [themeColors] = React.useState<string[]>(["#ffdd00", "#fbb034"]);
  const [isShowInHomePage, setIsShowInHomePage] = React.useState<boolean>(true);
  const [isShowPVOnePoint, setIsShowPVOnePoint] = React.useState<boolean>(true);

  React.useEffect(() => {
    navigationRef.current?.addListener("state", (e) => {
      // You can get the raw navigation state (partial state object of the root navigator)
      // Or get the full state object with `getRootState()`
      if (navigationRef.current?.getCurrentRoute()?.name === ScreenNameType.HOME) {
        setIsShowInHomePage(true);
      } else {
        setIsShowInHomePage(false);
      }
      if (navigationRef.current?.getCurrentRoute()?.name === ScreenNameType.PV_ONE) {
        setIsShowPVOnePoint(false);
      } else {
        setIsShowPVOnePoint(true);
      }
    });
  }, []);

  const onPressLogo = React.useCallback(() => {
    hideMenu();
    navigationRef.current?.dispatch(StackActions.replace(ScreenNameType.HOME));
  }, [hideMenu]);

  const onPressFooterBrand = React.useCallback(() => {
    hideMenu();
    navigationRef.current?.navigate(ScreenNameType.LIST_ABOUT_US);
  }, [hideMenu]);

  const styles = StyleSheet.create({
    footerDrawer: {
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 12,
      paddingHorizontal: spacing.huge,
      paddingVertical: spacing.medium,
    },
    flex: {
      flex: 1,
    },
    container: {
      flex: 1,
      backgroundColor: "transparent",
    },
    imageStyles: {
      width: 96,
      height: 78,
      alignSelf: "center",
      resizeMode: "contain",
    },
    titleFooterStyles: {
      color: colors.accent,
      ...fonts.semibold,
    },
  });

  return (
    <LinearGradient colors={themeColors} style={styles.flex}>
      <View style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ maxHeight: height }}>
          <Pressable onPress={onPressLogo}>
            <Image resizeMode="contain" source={images.logoPVCB} style={styles.imageStyles as ImageStyle} />
          </Pressable>
          <Block ph={spacing.medium}>
            <AccountInfo />
          </Block>
          <StackSpacing size="medium" />
          <Block ph={spacing.medium}>{isShowPVOnePoint ? <BoxRedeem /> : <></>}</Block>
          <StackSpacing size="medium" />
          <Block display={isShowInHomePage ? "flex" : "none"} mb={spacing.medium} ph={spacing.medium}>
            <MyQrCode />
          </Block>
          <Block display={!isShowInHomePage ? "flex" : "none"} mb={spacing.medium} ph={spacing.medium}>
            <ShortcutLink />
          </Block>
          <Block display={isShowInHomePage ? "flex" : "none"} mb={spacing.medium} ph={spacing.medium}>
            <Pressable onPress={onPressFooterBrand} style={{ flex: 1 }}>
              <Surface style={styles.footerDrawer}>
                <Paragraph style={styles.titleFooterStyles}>PV ONLINE BANKING</Paragraph>
              </Surface>
            </Pressable>
          </Block>
          <StackSpacing size="medium" />
        </ScrollView>
      </View>
    </LinearGradient>
  );
};

export default AsideLeft;
